import { FC } from "react"

import styles from "./XManager.module.scss"

export type XManagerProps = {
  children: any
  maximize?: boolean
}

export type XManagerExtensions = {
  Title: typeof Title
  Subtitle: typeof Subtitle
}

export const XManager: FC<XManagerProps> & XManagerExtensions = ({
  maximize = false, children
}) => {
  return (
    <>
      <div className={styles.manager}>
        <div className={"container" + (maximize ? " " + styles.maximize : "")}>
          <div className="row">
            <div className="col-12">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export type XTitleProps = {
  children?: any
}

export const Title: FC<XTitleProps> = ({ children }) => {
  return (
    <>
      <h1 className={styles.xtitle}>{children}</h1>
    </>
  )
}

export const Subtitle: FC<XTitleProps> = ({ children }) => {
  return (
    <>
      <h4 className={styles.xsubtitle}>{children}</h4>
    </>
  )
}

XManager.Title = Title
XManager.Subtitle = Subtitle